/* Dermatinta · micro-animaciones de conversión v2 (CRO).
   1) El contador del carrito salta cuando cambia. 2) Barra de lectura en artículos del blog.
   3) Escalones de descuento en el carrito. 4) Crossfade suave al cambiar imágenes en galerías.
   Sin dependencias; si no carga, la tienda funciona igual. */
(function () {
  'use strict';
  if (window.DTConversion) return;
  window.DTConversion = true;

  /* 1 · Contador del carrito */
  function vigilarContador(el) {
    var antes = el.textContent;
    new MutationObserver(function () {
      var ahora = el.textContent;
      if (ahora === antes) return;
      var subio = (+ahora || 0) > (+antes || 0);
      antes = ahora;
      if (!subio) return;
      el.classList.remove('dt-salto');
      void el.offsetWidth;
      el.classList.add('dt-salto');
    }).observe(el, { childList: true, characterData: true, subtree: true });
    el.addEventListener('animationend', function () { el.classList.remove('dt-salto'); });
  }

  /* 2 · Barra de lectura: progreso dentro del texto del artículo */
  function barraLectura() {
    var texto = document.querySelector('[data-articulo-texto]');
    var barra = document.querySelector('[data-lectura]');
    if (!texto || !barra) return;
    var pendiente = 0;
    function medir() {
      pendiente = 0;
      var r = texto.getBoundingClientRect();
      var alto = window.innerHeight || document.documentElement.clientHeight;
      var total = r.height - alto * 0.6;
      var leido = total > 0 ? Math.min(1, Math.max(0, (alto * 0.4 - r.top) / total)) : 1;
      barra.style.setProperty('--dt-leido', leido.toFixed(3));
    }
    function pedir() { if (!pendiente) pendiente = requestAnimationFrame(medir); }
    addEventListener('scroll', pedir, { passive: true });
    addEventListener('resize', pedir, { passive: true });
    medir();
  }

  /* 3 · Escalones de descuento en el carrito */
  function escalones() {
    var caja = document.querySelector('[data-escalon]');
    var crudo = (window.DT && window.DT.escalones) || '';
    if (!caja || !crudo) return null;
    var lista = crudo.split(',').map(function (t) {
      var p = t.split(':'); return { min: parseInt(p[0], 10), pct: parseFloat(p[1]) };
    }).filter(function (e) { return e.min > 0 && e.pct > 0; }).sort(function (a, b) { return a.min - b.min; });
    if (!lista.length) return null;
    var txt = caja.querySelector('[data-escalon-txt]');
    var fill = caja.querySelector('[data-escalon-fill]');
    var tope = lista[lista.length - 1];
    function pct(n) { return String(n).replace('.', ','); }
    return function pintar(n) {
      n = parseInt(n, 10) || 0;
      if (n < 1) { caja.hidden = true; return; }
      var actual = null, siguiente = null;
      lista.forEach(function (e) { if (n >= e.min) actual = e; else if (!siguiente) siguiente = e; });
      var falta = siguiente ? siguiente.min - n : 0;
      var mensaje;
      if (!siguiente) mensaje = '<b>✓ Tienes el ' + pct(actual.pct) + '% de descuento automático.</b> Lo ves aplicado en el subtotal.';
      else if (actual) mensaje = '<b>✓ ' + pct(actual.pct) + '% aplicado.</b> Con ' + falta + ' más, pasa a ' + pct(siguiente.pct) + '%.';
      else mensaje = 'Con <b>' + falta + ' producto' + (falta === 1 ? '' : 's') + ' más</b>, el carrito descuenta ' + pct(siguiente.pct) + '% automáticamente.';
      txt.innerHTML = mensaje;
      caja.classList.toggle('escalon--listo', !siguiente);
      fill.style.transform = 'scaleX(' + Math.min(1, n / tope.min).toFixed(3) + ')';
      caja.hidden = false;
    };
  }

  /* 4 · Crossfade suave al cambiar de foto en la galería de compra o PDP */
  function animarCambioGaleria() {
    Array.prototype.forEach.call(document.querySelectorAll('.galeria__main img, .pdp__principal img'), function (img) {
      var srcAnterior = img.getAttribute('src');
      new MutationObserver(function () {
        var nuevo = img.getAttribute('src');
        if (!nuevo || nuevo === srcAnterior) return;
        srcAnterior = nuevo;
        img.classList.add('dt-img-swap');
        setTimeout(function () { img.classList.remove('dt-img-swap'); }, 140);
      }).observe(img, { attributes: true, attributeFilter: ['src'] });
    });
  }

  function iniciar() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), vigilarContador);
    var pintarEscalon = escalones();
    var contador = document.querySelector('[data-cart-count]');
    if (pintarEscalon && contador) {
      pintarEscalon(contador.textContent);
      new MutationObserver(function () { pintarEscalon(contador.textContent); })
        .observe(contador, { childList: true, characterData: true, subtree: true });
    }
    barraLectura();
    animarCambioGaleria();
    if (window.DTStoryMotion && typeof window.DTStoryMotion.refresh === 'function') window.DTStoryMotion.refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar, { once: true });
  else iniciar();
}());
